export default __webpack_public_path__ + "static/media/the_world.d8270367.png";